import { validateCouponCodeInit, validateCouponCodeSuccess, validateCouponCodeFail, redeemCouponCodeSuccess, redeemCouponCodeInit, redeemCouponCodeFail } from "store/modules/couponcodes/actions";
import { Operation, User } from '.';
import * as API from 'api';
import { httpRequest } from './initialize'
import { Subscriptions } from "store";

/** Validate Coupon/Backer Code */
export function fetchCouponCodeInfo(code: string, dispatch) {
    dispatch(validateCouponCodeInit(code));
    return API.CouponCodes.validate(httpRequest, { code })
        .then((result) => {
            dispatch(validateCouponCodeSuccess(result));
            if (result.plan) {
                API.Analytics.planSelected(result.plan, code);
            }
            return result;
        })
        .catch(err => {
            dispatch(validateCouponCodeFail());
            Operation.onFail("Coupon code validation failed", dispatch, err);
        });
}


/** Submit/Redeem Coupon Code */
export function redeemCouponCode(code: string, dispatch) {
    dispatch(redeemCouponCodeInit());
    return API.CouponCodes.redeem(httpRequest, { code })
        .then((result) => {
            if (result && result.success) {
                dispatch(redeemCouponCodeSuccess());
                if (result.subscription && result.subscription.id) {
                    // New subscription plan redeemed
                    API.Analytics.planSubscriptionCompleted(result.code.plan, result.code.id, result.subscription.status);
                    dispatch(Subscriptions.newSubscriptionSuccess(result.subscription.id));
                    //ToDo: review if we can update local record from result instead of loading the user again
                    User.loadUserInformation(dispatch).then((user) => {
                        Operation.onSuccess('Hurray!', dispatch, 'You will receive an email with your subscription details and instructions to download our beta app.');
                    });
                } else {
                    // Other type (credit) of code redeemed
                    Operation.onSuccess('Coupon code redeemed successfully', dispatch);
                }
                //Reload User Account To make sure we have the subscription/discounts

                return result;
            }
            else {
                throw new Error("Failed to redeem code");
            }
        })
        .catch(err => {
            dispatch(redeemCouponCodeFail());
            Operation.onFail("Redemption of coupon code  failed", dispatch, err);
            throw err;
        });
}




// WEBPACK FOOTER //
// ./src/application/couponeCode.ts